import {Fragment, useMemo} from 'react';

import {Text} from '../../../../../component/text/text';
import {Locale} from '../../../../../provider/locale/locale';
import {ReviewsAndAnswersStatisticsUnitMeasurementEnum} from '../../../../../service/reviews-and-answers-statistics/reviews-and-answers-statistics';
import {classNames} from '../../../../../util/css';
import {useFormat} from '../../../../../util/format-hook/format-hook';

import {AverageResponseTimePartType, getAverageResponseTimeParts} from './average-response-time-value-helper';
import * as styles from './average-response-time-value.scss';

type PropsType = {
    seconds?: number | null;
    large?: boolean;
    danger?: boolean;
    timeUnit: ReviewsAndAnswersStatisticsUnitMeasurementEnum;
};

export function AverageResponseTimeValue(props: PropsType): JSX.Element {
    const {seconds, large, danger, timeUnit} = props;

    const {getFormattedNumber} = useFormat();

    const parts = useMemo((): Array<AverageResponseTimePartType> | null => {
        if (typeof seconds === 'number') {
            return getAverageResponseTimeParts(seconds, timeUnit);
        }

        return null;
    }, [timeUnit, seconds]);

    return (
        <Text
            block
            className={classNames({
                [styles.AverageResponseTimeValue__large]: large,
                [styles.AverageResponseTimeValue__danger]: danger,
            })}
        >
            {parts
                ? parts.map((part: AverageResponseTimePartType, index: number) => (
                      <Fragment key={part.unitStringKey}>
                          {index > 0 ? ' ' : ''}
                          {getFormattedNumber(part.count)}
                          <span
                              className={classNames(styles.AverageResponseTimeValue_unit, {
                                  [styles.AverageResponseTimeValue__danger]: danger,
                              })}
                          >
                              {' '}
                              <Locale stringKey={part.unitStringKey} />
                          </span>
                      </Fragment>
                  ))
                : '–'}
        </Text>
    );
}
